"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceLoader = void 0;
const path = require("path");
/** Template resource loader. */
class ResourceLoader {
    constructor(bucket, templateId) {
        this.templateId = templateId;
        this.resourcesDirectory = bucket.getDir(templateId);
    }
    /** Loads as text the resource identified by the uri. */
    load(uri) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.loadContent(uri)).getString();
        });
    }
    /** Loads as binary the resource identified by the uri. */
    loadBinary(uri) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.loadContent(uri)).getBuffer();
        });
    }
    /** Loads all resources. */
    loadAll() {
        return __awaiter(this, void 0, void 0, function* () {
            const fileMap = {};
            const files = yield Promise.all(yield this.resourcesDirectory.getFiles());
            yield Promise.all(files.map((file) => __awaiter(this, void 0, void 0, function* () {
                const key = path.basename(file.getFileDetails().name);
                const content = yield file.download();
                if (content === undefined) {
                    throw new Error(`Cannot find resource ${key} for template ${this.templateId}`);
                }
                fileMap[key] = content.getString();
            })));
            return fileMap;
        });
    }
    loadContent(uri) {
        return __awaiter(this, void 0, void 0, function* () {
            const content = yield this.resourcesDirectory.getFile(uri).download();
            if (content === undefined) {
                throw new Error(`Cannot find resource ${uri} for template ${this.templateId}`);
            }
            return content;
        });
    }
}
exports.ResourceLoader = ResourceLoader;
//# sourceMappingURL=resource_loader.js.map